import { Component, Output, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';
import { MessageDialog } from '../message-dialog/messageDialog';

@Component({
  selector: 'app-image-uploader',
  templateUrl: './image-uploader.component.html',
  styleUrls: ['./image-uploader.component.scss']
})
export class ImageUploaderComponent {

  @Input() isStamp = false;
  @Output() imageSelected = new EventEmitter<{ name: string; mimeType: string; imageData: string; base64FullData: string }>();
  @Output() stampSelected = new EventEmitter<{ name: string; mimeType: string; imageData: string; base64FullData: string  }>();
  @ViewChild('fileInput') fileInput: ElementRef;
  base64Image: string;

  constructor(private _messageDialog: MessageDialog) { }

  handleClick(event: Event): void {
    event.preventDefault();
    this.fileInput.nativeElement.click();
  }

  handleFileSelected(event: Event) {
    const fileInput = event.target as HTMLInputElement;
    const file = fileInput.files[0];

    if (file && file.type === 'image/png') {
      const image = new Image();
      image.onload = () => {
        if (image.width === 512 && image.height === 512) {
          if (file.size <= 2 * 1024 * 1024) {
            const reader = new FileReader();
            reader.onload = () => {
              const base64FullData = reader.result as string;
              const base64String = (reader.result as string).split(',')[1];

              const imageDetails = {
                name: file.name,
                mimeType: file.type,
                imageData: base64String,
                base64FullData: base64FullData,
              };

              if (this.isStamp) {
                this.stampSelected.emit(imageDetails);
              } else {
                this.imageSelected.emit(imageDetails);
              }
            };
            reader.readAsDataURL(file);
          } else {
            this._messageDialog.ShowAlert(
              'Error subir imagen',
              'El tamaño de la imagen no puede superar los 2MB'
            );
          }
        } else {
          this._messageDialog.ShowAlert(
            'Error subir imagen',
            'Las dimensiones de la imagen deben ser 512x512 px'
          );
        }
      };
      image.src = URL.createObjectURL(file);
    } else {
      this._messageDialog.ShowAlert(
        'Error subir imagen',
        'Formato inválido, seleccione una imagen PNG'
      );
    }

    // Limpiar el valor del input file para permitir la selección del mismo archivo nuevamente
    fileInput.value = '';
  }
}
